/* Skeletons.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _24 = "@media not all and (min-width:30rem){._1qwo1osq{width:100%}}";
const _23 = "._1bsbhv4l{width:65%}";
const _22 = "._1tke1414{min-height:30rem}";
const _21 = "._2lx21bp4{flex-direction:column}";
const _20 = "._1e0c1txw{display:flex}";
const _19 = "._1bsb1osq{width:100%}";
const _18 = "._p12foqa0{max-width:var(--_1m0m4uv)}";
const _17 = "._otyrpj13{margin-bottom:var(--_1shd6cj)}";
const _16 = "._19pk1usy{margin-top:var(--_m1ay97)}";
const _15 = "._4t3i10e5{height:var(--_16reqip)}";
const _14 = "._1bsbn9jh{width:var(--_pcenyd)}";
const _13 = "._2rko1a5o{border-radius:var(--_k65kcp)}";
const _12 = "@media (min-width:64rem){._2oz41v6z{border-radius:7px}._10jx33sj{max-width:659px}._15ri163w{min-width:230px}._glte1osq{width:100%}._165tdlk8{height:14px}}";
const _11 = "@media (min-width:48rem){._1kkm1y44{border-radius:4px}._14b5r4m3{width:331px}._1xloftgi{height:8px}}";
const _10 = "._4t3i1crf{height:9pt}";
const _9 = "._1bsb1178{width:280px}";
const _8 = "._2rkoi2wt{border-radius:6px}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { Hide, Show } from '@atlaskit/primitives/responsive';
import { skeletonShimmer } from '@atlaskit/theme';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "@keyframes k154l9z9{0%{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}to{background-color:var(--ds-skeleton-subtle,rgba(9,30,66,.08))}}";
const _6 = "._7hjf1yy8{animation-direction:alternate}";
const _5 = "._1pglp3kn{animation-timing-function:linear}";
const _4 = "._tip812c5{animation-iteration-count:infinite}";
const _3 = "._5sag12o8{animation-duration:1.5s}";
const _2 = "._bfhk1mnh{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}";
const _ = "._j7hq19hg{animation-name:k154l9z9}";
const shimmer = skeletonShimmer();
export const Skeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Skeleton.displayName = 'Skeleton';
}
export const MatchingLabelSkeleton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _2, _3, _4, _5, _6, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoi2wt _1bsb1178 _4t3i1crf _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _1kkm1y44 _14b5r4m3 _1xloftgi _2oz41v6z _10jx33sj _15ri163w _glte1osq _165tdlk8", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  MatchingLabelSkeleton.displayName = 'MatchingLabelSkeleton';
}
export const Stripe = forwardRef((_ref3, __cmplr) => {
  var _cmplp$width, _cmplp$height, _cmplp$borderRadius, _cmplp$marginTop, _cmplp$marginBottom;
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_pcenyd": ix((_cmplp$width = __cmplp.width) !== null && _cmplp$width !== void 0 ? _cmplp$width : '100%'),
        "--_16reqip": ix((_cmplp$height = __cmplp.height) !== null && _cmplp$height !== void 0 ? _cmplp$height : '16px'),
        "--_k65kcp": ix((_cmplp$borderRadius = __cmplp.borderRadius) !== null && _cmplp$borderRadius !== void 0 ? _cmplp$borderRadius : "var(--ds-radius-large, 8px)"),
        "--_m1ay97": ix((_cmplp$marginTop = __cmplp.marginTop) !== null && _cmplp$marginTop !== void 0 ? _cmplp$marginTop : "var(--ds-space-0, 0px)"),
        "--_1shd6cj": ix((_cmplp$marginBottom = __cmplp.marginBottom) !== null && _cmplp$marginBottom !== void 0 ? _cmplp$marginBottom : "var(--ds-space-0, 0px)"),
        "--_1m0m4uv": ix(__cmplp.maxWidth)
      }),
      ref: __cmplr,
      className: ax(["_2rko1a5o _1bsbn9jh _4t3i10e5 _19pk1usy _otyrpj13 _p12foqa0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Stripe.displayName = 'Stripe';
}
const Container = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const HeaderSkeleton = _ref5 => {
  let {
    testId
  } = _ref5;
  return /*#__PURE__*/_jsxs(Container, {
    "data-testId": testId,
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "60%"
    }), /*#__PURE__*/_jsx(Show, {
      above: "sm",
      children: /*#__PURE__*/_jsx(Stripe, {
        height: "14px",
        width: "90%",
        marginTop: "var(--ds-space-300, 24px)"
      })
    }), /*#__PURE__*/_jsxs(Hide, {
      above: "sm",
      children: [/*#__PURE__*/_jsx(Stripe, {
        height: "14px",
        marginTop: "var(--ds-space-250, 20px)"
      }), /*#__PURE__*/_jsx(Stripe, {
        height: "14px",
        marginTop: "var(--ds-space-250, 20px)"
      })]
    })]
  });
};
const AppListing2LineSkeletonContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21, _22, _23, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1tke1414 _1bsbhv4l _1qwo1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppListing2LineSkeletonContainer.displayName = 'AppListing2LineSkeletonContainer';
}
export const AppListing2LineSkeleton = _ref7 => {
  let {
    testId
  } = _ref7;
  return /*#__PURE__*/_jsxs(AppListing2LineSkeletonContainer, {
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "55%",
      height: "1rem",
      marginTop: "var(--ds-space-500, 40px)"
    }), /*#__PURE__*/_jsx(Stripe, {
      width: "100%",
      height: "1rem",
      marginTop: "var(--ds-space-300, 24px)"
    })]
  });
};